<div class="user-password-modal">
  <h2>Réinitialisation de votre mot de passe</h2>

  <p>
    Votre mot de passe n'a pas encore été choisi, ou a été réinitialisé.
    Veuillez choisir un nouveau mot de passe ci-dessous avant de continuer.
    Vous pourrez toujours vous authentifier soit par mail, soit par mot de passe.
  </p>

  <form class="password-form form-table" #theForm
        (ngSubmit)="onSubmit(theForm.valid)">
    <div class="row">
      <label>Nouveau mot de passe</label>
      <input type="password" pInputText
             name="password1"
             [(ngModel)]="password1"
             [min]="6"
      >
    </div>
    <div class="row">
      <label>Confirmation</label>
      <input type="password" pInputText
             name="password2"
             [(ngModel)]="password2"
             [min]="6"
      >
    </div>
    <div class="row error">
      <div  *ngIf="password1 && password2 && password1 != password2">
        Les mots de passe ne correspondent pas
      </div>
    </div>

    <div class="actions">
      <input type="submit" hidden>
      <a class="lifeislife-button-link"
         title="Enregistrer" i18n-title
         [class.disabled]="theForm.invalid || (busy$ | async)"
         (click)="onSubmit(theForm.valid);">
        <span>Enregistrer</span>
      </a>
    </div>

  </form>
</div>
